import { BASE_URL } from '../../App'
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Row, Col, Card } from 'antd';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import ReceiptLongTwoToneIcon from '@mui/icons-material/ReceiptLongTwoTone';
import LocalPrintshopTwoToneIcon from '@mui/icons-material/LocalPrintshopTwoTone';
import LOGO from '../image/cri_logo.jpg';
import CustomTextField from "../Reusable/Numerictext";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormGroup, Stack, Backdrop, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, List, ListItem, ListItemText, Checkbox, Grid, FormControlLabel } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';

export default function PriceList() {

    const [isTermsAndConditionsOpen, setTermsAndConditionsOpen] = useState(false);
    const [isPrice_ListOpen, setPrice_list] = useState(false);
    const [subdealerlist, setsubdealerlist] = useState([]);
    const [categories, setCategories] = useState(null);
    const [region, setRegion] = useState([]);
    const [ItemList, setItemList] = useState([]);
    const [ItemList1, setItemList1] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    // const [selecteddealer, setselecteddealer] = useState(null);
    const [SelectedRegionCode, setSelectedRegionCode] = useState(null);
    const [SelectedSector, setSelectedSector] = useState(null);
    const [showCard, setShowCard] = useState(false);
    const [showCardserial, setShowCardserial] = useState(false);
    const [open, setOpen] = React.useState(false);

    const [selectedItems, setSelectedItems] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [priceListData, setPriceListData] = useState(null);
    const [address, setAddress] = useState(null);


    const [selectedGroup, setselectedGroup] = useState('');
    const [selecteditem, setselecteditem] = useState(null);

    const BRANCH_CODE = localStorage.getItem('BRANCH_CODE');
    const token = localStorage.getItem('Token');
    const headers = { Authorization: `Bearer ${token}` };
    const [selectedValue, setSelectedValue] = useState({});

    const [selectedDate, setSelectedDate] = useState(dayjs());
    const login_id = localStorage.getItem("LOGIN_ID");
    //const login_id = '5103176';
    const handleDateChange = (newDate) => {
        setSelectedDate(newDate);
    };
const formattedDate = selectedDate ? dayjs(selectedDate).format('DD/MM/YYYY') : '';
    const handleToggle = (value) => () => {
        const currentIndex = selectedItems.indexOf(value);
        const newSelectedItems = [...selectedItems];

        if (currentIndex === -1) {
            newSelectedItems.push(value);
        } else {
            newSelectedItems.splice(currentIndex, 1);
        }

        setSelectedItems(newSelectedItems);
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([]);
        } else {
            const allItems = ItemList.map((item) => item.description);
            setSelectedItems(allItems);
        }
        setSelectAll(!selectAll);
    };

    const handleClose = (isCheckboxChecked) => {
        if (isCheckboxChecked) {
            setTermsAndConditionsOpen(false);
        } else {
            const checkbox = document.getElementById('terms-checkbox');
            if (checkbox) {
                setTermsAndConditionsOpen(false);
                Swal.fire({
                    icon: "warning",
                    text: 'Please agree to the terms and conditions by checking the box.'
                }).then((result) => {
                    if (result.isConfirmed) {
                        setTermsAndConditionsOpen(true);
                        checkbox.focus();
                    }
                });
            }
        }
    };
    const handleClose1 = () => {
        setPrice_list(false);
    };
    useEffect(() => {
        // Sundealerlist();
    }, []);
    useEffect(() => {
        const fetchData = async () => {
            try {
                setOpen(true);
                const response = await axios.post(BASE_URL + '/getsubdelaerlist', { dealer_code: login_id });
                // const response = await axios.post(BASE_URL + '/getsubdelaerlist', { dealer_code: '5103176' });
                if (response.status === 200) {
                    setsubdealerlist(response.data.getsubdelaerlist);
                    setOpen(false);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                    setOpen(false);
                }
            } catch (error) {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                    setOpen(false);
                } else if (error.request) {
                    console.error('No response received');
                    setOpen(false);
                } else {
                    console.error('Error setting up the request:', error.message);
                    setOpen(false);
                }
            }
        };
        fetchData();
    }, []);


    const [subgrouppcode, setsubgrouppcode] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {

                const response = await axios.post(BASE_URL + '/getproductgroup', { dealer_code: login_id });
                if (response.status === 200) {
                    setsubgrouppcode(response.data.getproductgroup);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            } catch (error) {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }
        };
        fetchData();
    }, []);

    const subgrouplist = subgrouppcode ? subgrouppcode.map((type) => ({
        Value: type.MATSUBGROUP_CODE,
        Label: type.DESCRIPTION,
    })) : [];



    const Subdealer_List = subdealerlist ? subdealerlist.map((type) => ({
        Value: type.retailer_code,
        Label: type.subdealername,
    })) : [];

    const ItemLists = ItemList1 ? ItemList1.map((type) => ({
        Value: type.ITEMCODE,
        Label: type.ITEMDESCRIPTION,
    })) : [];


    const [rptname, setrptname] = useState([]);
    const [rptcode, setrptcode] = useState([]);


    const [selectedDealer, setSelectedDealer] = useState(null);
    const [selectedDealername, setSelectedDealername] = useState('');

    // const handleDealerChange = (newValue) => {
    //     console.log("Selected newValue:", newValue); // Log the entire newValue

    //     if (newValue && newValue.Value && newValue.Label) {
    //         // Set the selected dealer and dealer name
    //         setSelectedDealer(newValue.Value);

    //         axios.post(BASE_URL + '/getcodeandplace', {
    //             dealercode: newValue.Value // Use the value for the API call
    //         })
    //         .then(response => {
    //             const responseData = response.data;
    //             const Reportname = responseData.getcodeandplace || [];
    //             setrptname(Reportname);
    //             console.log("Fetched Report Name:", rptname);
    //         })
    //         .catch(error => {
    //             // Handle errors
    //             console.error('API Error:', error);
    //         });
    //     } else {
    //         console.error('Invalid newValue structure:', newValue);
    //     }
    // };

    // State to store the selected dealer



    const handleDealerChange = (event, newValue) => {
        // const response = await axios.post(BASE_URL + '/getsubdelaerlist', { dealer_code: login_id });
        setSelectedDealer(newValue);
        // setSelectedDealername(newValue.Label);
        console.log("deler", newValue.Label);
        if (newValue) {
            axios.post(BASE_URL + '/getcodeandplace', {
                // dealercode: newValue.Value
                dealercode: newValue.Value

            })
                .then(response => {
                    const responseData = response.data;
                    const Reportname = responseData.getcodeandplace || [];
                    setrptname(Reportname);
                    console.log(rptname)
                })
                .catch(error => {
                    // Handle errors
                    console.error('API Error:', error);
                });
        }
    };


    //handlitemChange

    const [selecteditemdesc, setselecteditemdesc] = useState('');

    const handlitemChange = (event, newValue) => {
        setShowCard(false);
        setOpen(true);
        setselecteditem(newValue);
        setselecteditemdesc(newValue.Label);

        console.log("itemdesc", selecteditemdesc);
        //alert(newValue);

        if (newValue) {
            axios.post(BASE_URL + '/getecode', {
                itemcode: newValue.Value

            })
                .then(response => {
                    const responseData = response.data;
                    const ecode = responseData.getecode || [];
                    setrptcode(ecode);
                    console.log(ecode)
                    setOpen(false);
                })
                .catch(error => {
                    // Handle errors
                    setOpen(false);
                    console.error('API Error:', error);
                });
        }
    };

    const handlGroupChange = (newValue) => {
        setShowCard(false);
        setOpen(true);
        setrptcode([]);
        setselectedGroup(newValue);

setselecteditem(null);
     
        if (newValue) {
            axios.post(BASE_URL + '/getitems', {
                dealer_code: login_id,
                matgroupcode: newValue
            })
                .then(response => {
                    const responseData = response.data;
                    const itemcodes = responseData.getitems || [];
                    setItemList1(itemcodes);
                    setOpen(false);
                    console.log(itemcodes)
                })
                .catch(error => {
                    // Handle errors
                    setOpen(false);
                    console.error('API Error:', error);
                });
        }
    };



    const handlePriceList = () => {
        setSelectedItems([]);
        setOpen(true);
        const data = { dealer_code: login_id, itemcode: rptcode.length > 0 ? rptcode[0].ecode : '', date: selectedDate.format('YYYY-MM-DD') };
        axios.post(BASE_URL + '/getserialnumbers'
            , data)
            .then(response => {
                if (response.status === 200) {
                    setItemList(response.data.getserialnumbers);
                    //  setTermsAndConditionsOpen(true);
                    setShowCard(true);
                    setOpen(false);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                        
                    });
                    setOpen(false);
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                    setOpen(false);
                } else if (error.request) {
                    console.error('No response received');
                    setOpen(false);
                } else {
                    console.error('Error setting up the request:', error.message);
                    setOpen(false);
                }
            });
    };


    const [refInvoiceNo, setRefInvoiceNo] = useState('');
    const [refNo, setRefNo] = useState('');
    const handlesubmit = () => {
        setOpen(true);

        const data = {

            comp_inv_no: refInvoiceNo,
            comp_inv_date: selectedDate.format('YYYY-MM-DD'),
            login_id: login_id,
            productgroupcode: selectedGroup,
            itemdescription: selecteditem ? selecteditem.Label : '',
            subdealercode: rptname.length > 0 ? rptname[0].subdealercode : '',
            communicationaddress: rptname.length > 0 ? rptname[0].communicationaddress : '',
            subdealername: selectedDealer ? selectedDealer.Label : '',
            reference: refNo,
            dealer_code: login_id,
            itemcode: rptcode.length > 0 ? rptcode[0].ecode : '',
            serialnumbers: selectedItems


        };

        axios.post(BASE_URL + '/subdealersalescreate', data)
            .then(response => {
                if (response.status === 200) {
                    setOpen(false);
                    Swal.fire({
                        icon: "success",
                        text: response.data.text || 'Data saved successfully!',
                    });
                    setShowCard(false)
                    //window.location.reload();
                     
                    setSelectedItems = [];

                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'

                    });
                    setOpen(false);
                    setSelectedItems = '';
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                         icon: "warning",
                        text: ` ${error.response.data.message}`
                    });
                    setOpen(false);

                } else if (error.request) {
                    console.error('No response received');
                    setOpen(false);
                } else {
                    console.error('Error setting up the request:', error.message);
                    setOpen(false);
                }
            });
    };

    //handlesubmit
    return (
        <>
            <br />
            <div className="container mt-5" style={{ justifyContent: 'center' }}>

                <br />

                <div className='row'>
                    <div className='col-md-4'>
                        <Autocomplete
                            options={Subdealer_List}
                            getOptionLabel={(option) => option.Label}
                            value={selectedDealer}
                            onChange={handleDealerChange}

                            style={{marginTop:"15px"}}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Name"
                                    variant="outlined"
                                    required
                                    fullWidth
                                />
                            )}
                        />
                    </div>

                    <div className='col-md-4'>
                        <CustomTextField
                            label="Code"
                            fullWidth
                            value={rptname.length > 0 ? rptname[0].subdealercode : ''}
                            margin="normal"
                            InputProps={{ readOnly: true }}
                        />
                    </div>

                    <div className='col-md-4'>
                        <CustomTextField
                            label="Place"
                            fullWidth
                            value={rptname.length > 0 ? rptname[0].communicationaddress : ''}
                            margin="normal"
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                </div>


                <div className='row'>
                    <div className='col-md-4'>
                        {/* <label >Ref /Invoice No</label> */}
                        <CustomTextField
                            label="Ref /Invoice No"
                            fullWidth
                            value={refInvoiceNo}
                            margin="normal"
                            onChange={(event) => setRefInvoiceNo(event.target.value)}
                        />
                    </div>
                    <div className='col-md-4'>
                        {/* /<label >Reference</label> */}
                        <CustomTextField

                            label="Reference"
                            fullWidth
                            onChange={(event) => setRefNo(event.target.value)}
                            margin="normal"

                        />
                    </div>
                    <div className='col-md-4'>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer
                                components={[
                                    'DatePicker',
                                    'MobileDatePicker',
                                    'DesktopDatePicker',
                                    'StaticDatePicker',
                                ]}
                            >

                                <Stack spacing={2} sx={{}}>
                                   
                                    <div>
									

                                        <DemoItem>
                                            
											<MobileDatePicker
              label="Reference Date"
              value={selectedDate}
              onChange={handleDateChange}
              renderInput={(params) => <TextField {...params} helperText={formattedDate} />}
              fullWidth
            />
                                        </DemoItem>
                                    </div>
                                </Stack>
                            </DemoContainer>
                        </LocalizationProvider>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-4'>
                        <SelectSearch
                            label="Product Description"
                            required={true}
                            options={subgrouplist}
                            value={selectedGroup}
                            onChange={handlGroupChange}
                        />
                    </div>
                    <div className='col-md-4'>

                        <Autocomplete
                            options={ItemLists}
                            getOptionLabel={(option) => option.Label}
                            value={selecteditem}
                            onChange={handlitemChange}
                            style={{marginTop:"15px"}}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="item Description"
                                    variant="outlined"
                                    required
                                />
                            )}
                        />

                        {/* <SelectSearch
                            label="item Description"
                            required={true}
                            options={ItemLists}
                            value={selecteditem}
                            onChange={handlitemChange}
                        /> */}
                    </div>
                    <div className='col-md-4'>
                        {/* <label >E-Code</label> */}
                        <CustomTextField

                            label="Ecode"
                            fullWidth
                            value={rptcode.length > 0 ? rptcode[0].ecode : ''}
                            margin="normal"
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                </div>
                <br />
                <div className='row'>
                    <Button size="small" fullWidth variant="contained" onClick={handlePriceList} ><b>View</b></Button>
                </div>
                <hr />
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                    <CircularProgress color="inherit" />
                </Backdrop>
                {/* {showCard ? (
                    <Card>
                        <center><b style={{ fontSize: '20px' }}>Serial numbers</b></center><hr />
                        <List>
                            <ListItem disablePadding>
                                <FormControlLabel
                                    control={<Checkbox size="small" checked={selectAll} onChange={handleSelectAll} />}
                                    label="Select All"
                                />
                            </ListItem>
                            <Grid container spacing={1}>
                                {ItemList && ItemList.map((name) => (
                                    <Grid item xs={3} key={name.SERIAL_NO}>
                                        <ListItem disablePadding>
                                            <Checkbox
                                                size="small"
                                                checked={selectedItems.indexOf(name.SERIAL_NO) !== -1 || selectAll}
                                                onChange={handleToggle(name.SERIAL_NO)}
                                            />
                                            <ListItemText primary={name.SERIAL_NO} />
                                        </ListItem>
                                    </Grid>
                                ))}
                            </Grid>
                        </List>

                        <center>
                            <br />
                            <Button size="small" fullWidth variant="contained" onClick={handlesubmit} >
                                <b>Submit</b>
                            </Button>
                        </center>
                    </Card>
                ) : (
                    <Card style={{
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        borderRadius: '10px',
                    }}>
                        <center>
                            <span>Please Select All Fields</span>
                        </center>
                    </Card>
                )} */}


{showCard ? (
    <Card>
        <center><b style={{ fontSize: '20px' }}>Serial Numbers</b></center><hr />
        {ItemList && ItemList.length > 0 ? (
            <List>
                <ListItem disablePadding>
                    <FormControlLabel
                        control={<Checkbox size="small" checked={selectAll} onChange={handleSelectAll} />}
                        label="Select All"
                    />
                </ListItem>
                <Grid container spacing={1}>
                    {ItemList.map((name) => (
                        <Grid item xs={3} key={name.SERIAL_NO}>
                            <ListItem disablePadding>
                                <Checkbox
                                    size="small"
                                    checked={selectedItems.indexOf(name.SERIAL_NO) !== -1 || selectAll}
                                    onChange={handleToggle(name.SERIAL_NO)}
                                />
                                <ListItemText primary={name.SERIAL_NO} />
                            </ListItem>
                        </Grid>
                    ))}
                </Grid>
            </List>
        ) : (
            <center>
                <span>No records found</span>
            </center>
        )}
        <center>
            <br />
            <Button size="small" fullWidth variant="contained" onClick={handlesubmit} >
                <b>Submit</b>
            </Button>
        </center>
    </Card>
) : (
    <Card style={{
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
    }}>
        <center>
            <span>Please Select All Fields</span>
        </center>
    </Card>
)}





                {isTermsAndConditionsOpen && (
                    <TERMSANDCONDITIONS onClose={handleClose} />
                )}
                {isPrice_ListOpen && (
                    <PRICE_LIST onClose={handleClose1} priceListData={priceListData} Address={address} />
                )}
            </div>
        </>
    );
};

const TERMSANDCONDITIONS = ({ onClose }) => {

    const [isCheckboxChecked, setCheckboxChecked] = useState(false);
    const [termsData, setTermsData] = useState([]);

    useEffect(() => {
        const data = { type: 'terms_and_conditions' };

        axios.post(BASE_URL + '/RcpPriceList', data)
            .then(response => {
                if (response.status === 200) {
                    setTermsData(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            });

    }, []);

    const handleBackdropClick = (event) => {
        event.stopPropagation();
    };

    const handleCheckboxChange = (event) => {
        setCheckboxChecked(event.target.checked);
    };

    const handleDialogClose = (event, reason) => {
        onClose(isCheckboxChecked);
    };
};

const PRICE_LIST = ({ onClose, priceListData, Address }) => {

    const [TaC, setSelectedItemsTermsAndConditions] = useState([]);

    const handleDialogClose = (event, reason) => {
        onClose();
    };


};